import React, { useEffect, useRef } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { STATUSARRAY } from "../../_contstants/common";
import { clearMachineDetails } from "./machineSlice";
import {
  createMachine,
  getAllMachine,
  getItemMachineById,
  updateMachine,
} from "./services/machine.services";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import FormRichTextField from "../../components/formFields/FormRichTextField";
import { findAllActiveMachineCleaning } from "../machinecleaning/services/machinecleaning.services";

const CreateMachine: React.FC = () => {
  const formLoading = useAppSelector((state) => state.machine.formLoading);
  const MachineDetail = useAppSelector((state) => state.machine.MachineDetail);
  const MachineGUID = useAppSelector((state) => state.muidrawer.data);
  const isIndirect = useAppSelector((state) => state.muidrawer.isIndirect);

  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  useEffect(() => {
    return () => {
      dispatch(clearMachineDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (MachineGUID) {
      dispatch(getItemMachineById(MachineGUID));
    }
  }, [MachineGUID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!MachineGUID) {
        const payload = {
          machine_name: values.machine_name,
          description: values.description,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(createMachine(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearMachineDetails());
          isIndirect
            ? dispatch(findAllActiveMachineCleaning())
            : dispatch(getAllMachine());
        }
      } else {
        const payload = {
          machine_guid: MachineGUID,
          machine_name: values.machine_name,
          description: values.description,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(updateMachine(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearMachineDetails());
          isIndirect
            ? dispatch(findAllActiveMachineCleaning())
            : dispatch(getAllMachine());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={MachineDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "17px 0 8px",
              }}
            >
              <Typography.h4 className="m-0">
                {MachineGUID ? "Update Machine" : "Add Machine"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => {
                  dispatch(closed());
                }}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="machine_name"
                label="Machine Name"
                placeholder="Machine Name"
                component={FormTextField}
                validator={requiredValidator} astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="description"
                label="Description"
                placeholder="Description"
                component={FormRichTextField}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"isactive"}
                name={"isactive"}
                label={"Status"}
                component={FormSelectionField}
                validator={requiredValidator} astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "start",
                marginTop: "20px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={MachineGUID ? "Update" : "Save"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateMachine;
